import React, { useEffect, useState } from "react";
import { Alert, Lab } from "../../../../backend/src/types";
import { getAlertsCount, getAlertsList, handleHiddenAlert } from "../../fetch/AlertRequest";
import "../../styles/sanitize.css";
import styles from "../../styles/modules/MainPage.module.css";
import { useUser } from "../../contexts/UserContext";

interface ExpireSoonListProps {
  onFinish: () => void;
  isLabAdmin: boolean;
  selectedLab: Lab;
}

type ExpireSoonAlert = Pick<Alert, "id" | "reagent_id" | "is_resolved"> & {
  name: string;
  capacity_base: number;
  display_unit: string;
  expires_at: string;
};

const ExpireSoonList: React.FC<ExpireSoonListProps> = ({
  onFinish,
  isLabAdmin,
  selectedLab,
}) => {
  const [expireSoonList, setExpireSoonList] = useState<ExpireSoonAlert[]>([]);
  const { user, userLabs, setAlertCount } = useUser();

  useEffect(() => {
    loadExpireSoonAlertList();
  }, [selectedLab]);

  async function loadExpireSoonAlertList() {
    const result = await getAlertsList<ExpireSoonAlert>({
      tenant_id: selectedLab.tenant_id,
      lab_id: selectedLab.id,
      category: "expire_soon",
    });

    setExpireSoonList(result);
    onFinish();
  }

  const handleHide = async (id: number) => {
    await handleHiddenAlert({ alertId: id });

    setExpireSoonList((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, is_resolved: true } : item,
      ),
    );

    if (user?.tenant_id) {
      const tenant_id = user?.tenant_id;
      const lab_ids = userLabs.map((lab) => lab.id);
      const alertCount = await getAlertsCount({ tenant_id, lab_ids });
      setAlertCount(alertCount);
    }
  };

  return (
    <div className={styles["alert-section"]}>
      <h3>満了予定一覧</h3>

      <table>
        <thead>
          <tr>
            <th>試薬名</th>
            <th>試薬ID</th>
            <th>サイズ</th>
            <th>満了日</th>
            {isLabAdmin && <th>非表示</th>}
          </tr>
        </thead>
        <tbody>
          {expireSoonList.filter((alert) => !alert.is_resolved).length > 0 ? (
            expireSoonList
              .filter((alert) => !alert.is_resolved)
              .map((alert) => (
                <tr key={alert.id}>
                  <td>{alert.name}</td>
                  <td>{alert.reagent_id}</td>
                  <td>
                    {alert.capacity_base}
                    {alert.display_unit}
                  </td>
                  <td>{alert.expires_at}</td>
                  {isLabAdmin && (
                    <td>
                      <button onClick={() => handleHide(alert.id)}>
                        非表示
                      </button>
                    </td>
                  )}
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan={isLabAdmin ? 5 : 4}>
                <p className="list-none">アラートなし</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ExpireSoonList;
